var map = {
	"./approve.png": "Gtpw",
	"./icon-close.png": "wOFH",
	"./icon-upload-success.png": "Gk6c",
	"./icon_close.png": "ShLw",
	"./icon_question.png": "Qd57",
	"./login-btn-bg.png": "pWgV",
	"./pdf-active.png": "c4ko",
	"./pdf.png": "Ta3C",
	"./ppt-active.png": "O2Tc",
	"./ppt.png": "LIYm",
	"./rejected.png": "j7Pw",
	"./result-img.png": "tqFJ",
	"./teaching-active.png": "xRWu",
	"./teaching-default.png": "SJJx",
	"./teaching.png": "B54S",
	"./video-active.png": "fJcI",
	"./video.png": "BXki",
	"./word-active.png": "lgxn",
	"./word.png": "NRYx",
	"./zip-active.png": "AHQ5",
	"./zip.png": "9ql2",
	"./天坛.png": "hsNz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 1